import * as React from 'react';
import styled from 'styled-components';
import FaqItem, { IFaqItem } from '@adecco/base-app/src/components/atoms/FaqItem/FaqItem';
import Headline from '@adecco/base-app/src/components/atoms/Headline/Headline';
import Container from '@adecco/base-app/src/components/atoms/Container/Container';
import { moreThan } from '@adecco/base-app/src/constants/breakpoints/breakpoints';
import { useAppContext } from '@adecco/base-app/src/utilities/appProvider/appProvider';

export interface IFaqList {
  title?: string;
  entries: ReadonlyArray<IFaqItem>;
  centeredHeadline?: boolean;
}

interface IFaqListItem {
  zIndex: number;
  itemsNumber: number;
  brand: string;
}

const FaqListItem = styled.div<IFaqListItem>`
  width: 100%;
  margin: ${(props) => props.theme.margins.listItem};
  ${(props) =>
    props.brand === 'ProServ' &&
    `
      z-index: ${props.itemsNumber - props.zIndex};
    `}
`;

const FAQHeadline = styled(Headline)`
  margin: ${(props) => props.theme.margins.headLine};
  font-size: ${(props) => props.theme.fontSizes.faqHeadline};
  line-height: ${(props) => props.theme.lineHeights.faqHeadline};
  font-family: ${(props) => props.theme.fonts.HeadlineBold};
  color: ${(props) => props.theme.colors.faqHeadline};

  ${moreThan('md')} {
    font-size: ${(props) => props.theme.fontSizes.headline2WideScreen};
    line-height: ${(props) => props.theme.lineHeights.headline2WideScreen};
  }
`;

const FaqList: React.FunctionComponent<IFaqList> = ({ title, entries, centeredHeadline }) => {
  const { brand } = useAppContext();
  return (
    <Container>
      <FAQHeadline skin={2} centered={centeredHeadline}>
        {title}
      </FAQHeadline>
      {entries.map((entry, index) => (
        <FaqListItem
          key={`jobFact-${index}`}
          brand={brand}
          zIndex={index}
          itemsNumber={entries.length}
        >
          <FaqItem {...entry} />
        </FaqListItem>
      ))}
    </Container>
  );
};

export default FaqList;
